var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('iframe',{attrs:{"id":'ifraHome'+_vm.page,"width":"100%","height":_vm.height + 'px',"src":(_vm.url + "/_apass/lookcustomV3?id=" + _vm.page),"frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }